import { createContext } from 'react';
import { MeetingData } from '../../../types/types';
import { pendingMeetingData } from '../../../../database/utils/templateMeetingData';

const PreviousMeetingDataContext = createContext<MeetingData>(pendingMeetingData);

export default PreviousMeetingDataContext;
